import { apiClient } from "@/lib/api/client";
import { apiPaths } from "@/lib/api/paths";
import useSWR, { type SWRConfiguration } from "swr";
import { config } from "@/config";
import type { GetQueries } from "@typings/api";
import { isEmpty } from "@utils/formatters";
import type { GetReleasesResponse, ReleasesFilters } from "./type";

async function getReleases(
  query: GetQueries<ReleasesFilters>,
): Promise<GetReleasesResponse> {
  const params = new URLSearchParams();

  Object.entries(query).forEach(([key, value]) => {
    if (isEmpty(value)) return;

    params.append(key, String(value));
  });

  let url = apiPaths.releases.list;
  if (params.toString()) {
    url += `?${params.toString()}`;
  }

  const response = await apiClient.get<GetReleasesResponse>(url);

  return response.data;
}

export function useGetReleases(
  query: GetQueries | null,
  options?: SWRConfiguration,
) {
  const mergedOptions: SWRConfiguration = {
    ...config.swr,
    ...options,
  };

  return useSWR(
    [`fetch-get-releases`, JSON.stringify(query ?? {})],
    () => getReleases(query ?? {}),
    mergedOptions,
  );
}
